<ng-container *ngFor="let item of iconVm">
  <button mat-icon-button *ngIf="item.enabled" (click)="onActionClick(item)" [matTooltip]="item.tooltip"
          matTooltipShowDelay="750">
    <mat-icon>{{ item.iconName }}</mat-icon>
  </button>
</ng-container>

<button mat-icon-button [matMenuTriggerFor]="contextMenu" matTooltip="weitere Aktionen" matTooltipShowDelay="750">
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #contextMenu="matMenu" class="action-context-menu">
  <ng-container *ngFor="let item of contextMenuVm; let isLastItem = last">
    <button mat-menu-item [disabled]="!item.enabled" (click)="onActionClick(item)" [matTooltip]="item.tooltip"
            matTooltipShowDelay="750">
      <mat-icon>{{ item.iconName }}</mat-icon>
      <span>{{ item.type | noticeActionTypeToLabel }}</span>
    </button>
    <mat-divider
      *ngIf="[VorlageActionType.DELETE_TEMPLATE, VorlageActionType.COPY_TEMPLATE].includes(item.type) && !isLastItem"></mat-divider>
  </ng-container>
</mat-menu>
